// Configuration constants - adjust these values as needed
const SHIPPING_CONFIG = {
  FREE_SHIPPING_THRESHOLD: 5000, // $100.00 in cents
  FREE_SHIPPING_MESSAGE: "<b>You've unlocked FREE SHIPPING!</b>",
  SHIPPING_MESSAGE_TEMPLATE: "You're <b>[price] away</b> from FREE SHIPPING",
};

const ShippingProgress = {
  init: function () {
    this.updateShippingProgress();
    this.bindEvents();
  },

  bindEvents: function () {
    // Listen for all relevant cart update events

    // Standard cart update event
    document.addEventListener('cart:updated', this.updateShippingProgress.bind(this));

    // Dawn-specific cart events
    document.addEventListener('cart:refresh', this.updateShippingProgress.bind(this));
    document.addEventListener('cart:change', this.updateShippingProgress.bind(this));

    // For cart drawer/flyout
    document.addEventListener('drawer:open', this.updateShippingProgress.bind(this));

    // Additional fallback for AJAX changes - watch for DOM changes
    this.setupMutationObserver();

    // Direct event listeners for common cart actions
    document.addEventListener('click', (event) => {
      // Check if clicked element is a cart item remove button
      if (event.target.matches('[data-cart-remove], [data-cart-remove] *, .cart-item__remove, .cart-item__remove *')) {
        // Wait for AJAX to complete
        setTimeout(this.updateShippingProgress.bind(this), 500);
      }

      // Check for quantity changes
      if (
        event.target.matches(
          '[data-cart-qty-adjust], [data-cart-qty-adjust] *, .cart-item__qty-adjust, .cart-item__qty-adjust *'
        )
      ) {
        // Wait for AJAX to complete
        setTimeout(this.updateShippingProgress.bind(this), 500);
      }
    });

    // Initial load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.updateShippingProgress.bind(this));
    } else {
      this.updateShippingProgress();
    }
  },

  setupMutationObserver: function () {
    // Watch for changes to the cart section
    // Include the custom cart-drawer element used by Dawn
    const cartContainer = document.querySelector('cart-drawer, .cart-drawer, #cart-drawer, .cart-items, .cart__items');
    if (!cartContainer) return;

    // Save a reference to whether we're currently updating
    let isUpdating = false;

    const observer = new MutationObserver((mutations) => {
      // Avoid triggering updates from our own DOM changes
      if (isUpdating) return;

      // Check if relevant mutations occurred
      const shouldUpdate = mutations.some((mutation) => {
        // Make sure the mutation isn't on our progress bar elements
        if (mutation.target.closest('.cart__progress_bar')) return false;

        // If nodes were added or removed
        if (mutation.addedNodes.length || mutation.removedNodes.length) return true;
        // If attributes changed on cart-related elements
        if (mutation.target.matches('.cart-item, .cart__item, [data-cart-item]')) return true;
        return false;
      });

      if (shouldUpdate) {
        isUpdating = true;
        this.updateShippingProgress();
        // Reset the flag after a short delay
        setTimeout(() => {
          isUpdating = false;
        }, 100);
      }
    });

    observer.observe(cartContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cart-item-quantity', 'value'],
    });
  },

  updateShippingProgress: function () {
    const progressBar = document.querySelector('.cart__progress_bar');
    if (!progressBar) return;

    // Store the current values before fetching new cart data
    const progressBarElement = progressBar.querySelector('.progress-bar');
    const messageElement = progressBar.querySelector('.progress_bar_shipping_message');

    // Add transition class to fade out
    progressBar.classList.add('updating');

    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const cartTotal = cart.total_price;
        const remainingAmount = SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLD - cartTotal;
        const percent = Math.floor((cartTotal * 100) / SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLD);
        const cappedPercent = percent > 100 ? 100 : percent;

        // Apply updates while content is faded out
        setTimeout(() => {
          // Update progress bar
          progressBarElement.style.width = cappedPercent + '%';
          progressBarElement.setAttribute('aria-valuenow', cappedPercent);
          progressBarElement.textContent = cappedPercent + '%';

          if (cappedPercent >= 100) {
            // Threshold reached
            progressBar.querySelector('.progress_bar_shipping').classList.add('success');
            messageElement.innerHTML = SHIPPING_CONFIG.FREE_SHIPPING_MESSAGE;
          } else {
            // Still need to spend more
            progressBar.querySelector('.progress_bar_shipping').classList.remove('success');
            const formattedPrice = this.formatMoney(remainingAmount);
            messageElement.innerHTML = SHIPPING_CONFIG.SHIPPING_MESSAGE_TEMPLATE.replace('[price]', formattedPrice);
          }

          // Fade back in after changes are applied
          setTimeout(() => {
            progressBar.classList.remove('updating');
          }, 50);
        }, 300); // Wait for fade-out to complete
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
        progressBar.classList.remove('updating');
      });
  },

  formatMoney: function (cents) {
    // Basic money formatter
    return '$' + (cents / 100).toFixed(2);
  },
};

// Initialize once the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    ShippingProgress.init();
  });
} else {
  ShippingProgress.init();
}
